import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Col, Container, Row, Card, Form } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import SideTab from "./Toolstab";
import pay from "../Images/pay.png";
import robot1 from "../Images/robot1.txt.svg";
import robot2 from "../Images/Robots.txt.png";
import {
  FaChartBar,
  FaChevronLeft,
  FaChevronRight,
  FaSearch,
} from "react-icons/fa";
import { Helmet } from "react-helmet";
const Robot = () => {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Seobix : Manage & Edit robots.txt for Better SEO Control",
    url: "https://seobix.com/manage-robots-txt",
    description:
      "Edit and manage your robots.txt file easily. Control crawler access, protect private pages, and boost your SEO with correct directives.",
    publisher: {
      "@type": "Organization",
      name: "Seobix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
      },
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Robots.txt",
          item: "https://seobix.com/manage-robots-txt",
        },
      ],
    },
    mainEntity: {
      "@type": "SoftwareApplication",
      name: "Manage Robots.txt Tool",
      applicationCategory: "SEO Tool",
      operatingSystem: "Web",
      offers: {
        "@type": "Offer",
        price: "0",
        priceCurrency: "USD",
        category: "Free SEO Tool",
      },
    },
    inLanguage: "en",
    keywords: [
      "create robots txt generator",
      "generator robot txt",
      "generate robots txt",
      "robots txt builder",
      "tester robots txt",
      "robots.txt manager",
      "robots.txt tool",
      "generate robots.txt",
      "validate robots.txt file",
      "robots.txt validation tool",
      "robots txt maker",
      "control crawler access",
      "robots.txt rules editor",
    ],
    mainEntityOfPage: [
      {
        "@type": "Question",
        name: "What is a robots.txt file?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "A robots.txt file is a text file on your website that instructs search engine crawlers which pages to index or ignore, helping control SEO and privacy.",
        },
      },
      {
        "@type": "Question",
        name: "How can I edit robots.txt using Seobix?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Seobix allows you to create, edit, and manage your robots.txt file easily using an intuitive interface, without manually coding.",
        },
      },
      {
        "@type": "Question",
        name: "Does managing robots.txt help SEO?",
        acceptedAnswer: {
          "@type": "Answer",
          text: "Yes, correctly managing robots.txt helps search engines crawl your site efficiently, protects sensitive pages, and can improve overall SEO performance.",
        },
      },
    ],
  };

  return (
    <div>
      <Helmet>
        <title> Manage & Edit robots.txt for Better SEO Control</title>
        <meta
          name="description"
          content="Edit and manage your robots.txt file easily. Control crawler access, protect private pages, and boost your SEO with correct directives."
        />
        <meta
          name="keywords"
          content="create robots txt generator, generator robot txt, generate robots txt, robots txt builder, tester robots txt, robots.txt manager, robots.txt tool, generate robots.txt, validate robots.txt file, robots.txt validation tool, robots txt maker, control crawler access, robots.txt rules editor"
        />
        <link rel="canonical" href="https://seobix.com/manage-robots-txt" />

        <meta
          property="og:title"
          content="Seobix : Manage & Edit robots.txt for Better SEO Control"
        />
        <meta
          property="og:description"
          content="Edit and manage your robots.txt file easily. Control crawler access, protect private pages, and boost your SEO with correct directives."
        />
        <meta
          property="og:url"
          content="https://seobix.com/manage-robots-txt"
        />
        <meta property="og:site_name" content="Seobix" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="600" />
        <meta property="og:locale" content="en_US" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Seobix : Manage & Edit robots.txt for Better SEO Control"
        />
        <meta
          name="twitter:description"
          content="Edit and manage your robots.txt file easily. Control crawler access, protect private pages, and boost your SEO with correct directives."
        />
        <meta
          name="twitter:image"
          content="https://seobix.com/Images/Backlinks.png"
        />
        <meta name="twitter:site" content="@seobix" />
        <meta name="twitter:creator" content="@seobix" />

        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
      </Helmet>
      <Nav />
      <Container fluid className="p-0 mt-5">
        <Row className="justify-content-center" style={{ margin: "0" }}>
          <Col md={10}>
            <Row className="justify-content-between">
              <Col md={8}>
                <ContentRobot />
              </Col>

              <Col md={3}>
                <div
                  className="mb-5"
                  style={{
                    position: "sticky",
                    top: "100px",
                    zIndex: 10,
                    background: "#f8f9fa",
                    padding: "1rem",
                    borderRadius: "10px",
                  }}
                >
                  <h5
                    className="text-center mb-4"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.3rem",
                      color: "#fff",
                      backgroundColor: "#799EFF",
                      display: "inline-block",
                      padding: "6px 16px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    🚀 Explore More SEO Tools
                  </h5>
                  <SideTab />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};

const ContentRobot = () => {
  return (
    <div>
      <Col>
        <div className="mx-2">
          <h1>Help the Google Crawlers & Manage Your Website </h1>

          <p>
            Welcome to SeoBix—the one-stop solution to boost your website's
            visibility and performance on search engines. With the present
            advancements in the digital world, managing your website effectively
            becomes a mandate, though smart means and tools are needed to do so.
            SeoBix thus simplifies the task of crawling Google and managing the
            SEO performance of your website.
          </p>
          <div className="d-flex justify-content-center mt-3">
            <img
              className="m-3"
              src={robot2}
              alt="seobix"
              style={{ width: "50vw" }}
            />
          </div>

          <h2>Google Crawlers–What Are They and Why Are They Important?</h2>

          <p>
            Google crawlers, or bots as they are commonly known, are automated
            programs that search engines deploy to discover and index content
            from throughout the web. These bots crawl through the links of your
            site and examine its design to determine the relevance and usability
            of your content from a user's perspective. Proper optimization for
            these crawlers is the bedrock of ensuring that your pages get
            indexed in the right way and rank very well in search results.
          </p>

          <h2>How Will SeoBix Help Guide Google Crawlers?</h2>

          <p>
            SeoBix includes features you can use to cut out of the optimization
            process of your website and make sure Google bots fully understand
            what your content relates to. Here is how it is done:
          </p>

          <h3>Optimization of Crawling Pathways</h3>

          <p>
            SeoBix follows a well-thought-out internal linking structure on your
            site so that crawlers can traverse easily through your site and
            quickly find all relevant pages. It optimally utilizes the crawl
            budget by ensuring that search engines gulp down time on
            high-priority pages.
          </p>

          <h3>Robots.txt Management</h3>

          <p>
            If you need to give instructions to search engines on what to crawl
            and what not to crawl, you can manage and create the robots.txt file
            comfortably from within SeoBix. Google will crawl the more important
            pages, thus saving resources and indexing key content better.
          </p>
          <Plancard />
          <h3>XML Sitemap Creation</h3>

          <p>
            SeoBix helps you create an optimized XML sitemap that takes Google
            to all of your important pages. This will not only aid Google in
            crawling your website more efficiently but also help discover new
            content quickly for indexing.
          </p>

          <h3>Structured Data Implementation</h3>

          <p>
            It is very important to implement structured data on your pages for
            the Google crawlers to understand your content better. SeoBix
            provides user-friendly applications for schema markup integration to
            improve search engine visibility and rich snippets for your pages.
          </p>

          <h3>Crawl Error Identification</h3>

          <p>
            With the detailed reports from SeoBix, it would be easy to spot
            crawl errors such as broken links or any page with something wrong
            that prevents it from being indexed kind of properly. Once you clear
            those up, Google should have easy access to your pages and be able
            to rank them without sticking points.
          </p>

          <h3>Page Speed Optimization</h3>

          <p>
            Google considers page speed an important ranking factor. Tools
            provided by SeoBix allow monitoring and improving your website
            speed, allowing the Google bots to crawl your site quickly, thereby
            enhancing your rankings.
          </p>
          <Plancard />
          <h2 className="text-center">Manage Your Website With SeoBix</h2>
          <div className="d-flex justify-content-center">
            <img
              className=""
              src={robot1}
              alt="seobix"
              style={{ width: "50vw" }}
            />
          </div>
          <p>
            SeoBix is not only a crawler manager but also a specialized platform
            for all-round management of your website's SEO performance. Some
            perspectives you can count on:
          </p>

          <ul>
            <li>
              <strong>Comprehensive Website Analytics:</strong> For an
              all-in-one online analytics solution that is able to track health,
              traffic, and performance metrics of your website in real time.
            </li>
            <li>
              <strong>Keyword Management:</strong> Optimize your site with the
              best-performing keywords and keep ahead of the pack.
            </li>
            <li>
              <strong>Content Recommendations:</strong> For taking action on
              gaps in content, keyword optimization, and other on-page SEO
              factors.
            </li>
            <li>
              <strong>Rank Tracking:</strong> Track your keyword rankings and
              reevaluate tactics based on the real-time data.
            </li>
            <li>
              <strong>Competitor Analysis:</strong> Look closer into what your
              competitors are doing and fine-tune your own strategies
              accordingly.
            </li>
          </ul>

          <div className="mt-5">
            <ToolSlider />
          </div>
          <h2>Reasons for Choosing SeoBix ?</h2>

          <ul>
            <li>
              <strong>User-friendly Interface:</strong> Anyone can use SeoBix,
              from beginners to experts; it is wonderfully designed for website
              optimization and management.
            </li>
            <li>
              <strong>Comprehensive Tools:</strong> From crawl management to
              complete content optimization, SeoBix has it all in one place for
              you.
            </li>
            <li>
              <strong>Data-Driven Insights:</strong> SeoBix provides real-time
              data-driven, actionable insights needed to improve the performance
              of your site.
            </li>
            <li>
              <strong>SEO Support:</strong> Contact our team of SEO experts for
              assistance in solving challenges to ensure your site delivers
              optimum performance.
            </li>
          </ul>

          <h2>Start Optimizing Your Website Today</h2>

          <p>
            Letting crawlers miss your content is basically like inviting
            misfortune to your door. Using SeoBix, you have complete control
            over managing your website while ensuring that Google crawls and
            indexes those pages precisely.
          </p>

          <p>
            So, sign up with SeoBix today and put your site on the right track
            to having a commanding search engine presence and crawlers right
            over to the best-prioritized pages.
          </p>
        </div>
        <Specialoffer />
      </Col>
    </div>
  );
};

const relatedTools = [
  {
    name: "On-Page SEO Analyzer",
    icon: <FaSearch size={24} color="#0A3981" />,
    desc: "Evaluate your web pages for on-page SEO factors like meta tags, header usage, internal links, and keyword density. Get suggestions to boost rankings.",
    href: "/on-page-seo-tool",
  },
  {
    name: "Structured Data Tester",
    icon: <FaChartBar size={24} color="#0A3981" />,
    desc: "Validate your website’s structured data (schema markup) for rich results in search. Ensure proper implementation for articles, products, events, and more.",
    href: "/structured-data-validator",
  },
  {
    name: "Complete SEO Inspector",
    icon: <FaChartBar size={24} color="#0A3981" />,
    desc: "Run a full SEO Inspector to identify site issues like broken links, slow loading speed, mobile usability, and missing structured data. Get actionable recommendations.",
    href: "/seo-Inspector",
  },
];
const ToolSlider = () => {
  const sliderRef = useRef(null);

  const scrollLeft = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft -= 300;
    }
  };

  const scrollRight = () => {
    if (sliderRef.current) {
      sliderRef.current.scrollLeft += 300;
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={scrollLeft}
        style={{
          position: "absolute",
          left: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronLeft />
      </button>

      <button
        onClick={scrollRight}
        style={{
          position: "absolute",
          right: "0",
          top: "-9%",
          transform: "translateY(-50%)",
          zIndex: 10,
          backgroundColor: "#799EFF",
          color: "#fff",
          border: "none",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          cursor: "pointer",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <FaChevronRight />
      </button>

      <div
        ref={sliderRef}
        className="mb-4"
        style={{
          display: "flex",
          overflowX: "auto",
          padding: "1rem",
          gap: "1rem",
          scrollbarWidth: "none",
          scrollBehavior: "smooth",
        }}
      >
        {relatedTools.map((tool, idx) => (
          <div
            key={idx}
            style={{
              minWidth: "250px",
              flex: "0 0 auto",
              background: "#f4f8ff",
              borderRadius: "12px",
              padding: "1rem",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              textAlign: "center",
              transition: "transform 0.3s",
            }}
          >
            <div style={{ marginBottom: "0.5rem" }}>{tool.icon}</div>
            <h6 style={{ color: "#0A3981", fontWeight: "bold" }}>
              {tool.name}
            </h6>
            <p
              style={{
                fontSize: "0.9rem",
                minHeight: "60px",
                lineHeight: "1.4",
              }}
            >
              {tool.desc
                .split(" ")
                .map((word, i) =>
                  (i + 1) % 7 === 0 ? word + "\n" : word + " "
                )
                .join("")
                .split("\n")
                .map((line, idx) => (
                  <span key={idx}>
                    {line.trim()}
                    <br />
                  </span>
                ))}
            </p>
            <a
              href={tool.href}
              style={{
                color: "#fff",
                backgroundColor: "#799EFF",
                padding: "6px 12px",
                borderRadius: "8px",
                textDecoration: "none",
                display: "inline-block",
                fontWeight: "bold",
              }}
            >
              Try Now →
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Robot;
